<template>
  <div class="smart">
    <!-- banner部分 -->
    <div class="smart-banner clearfix">
      <div>
        <h2>智慧校园</h2>
        <h3>LED大屏显示系统</h3>
      </div>
    </div>
    <!-- 方案概述 -->
    <div class="container clearfix">
      <div class="smart-title">方案概述</div>
      <div class="smart-overview">
        <div>
          <h2>LED大屏显示系统</h2>
          <p>我们在设计和采取的技术措施上，可以根据需求可以分区显示，每区显示内容可不同，使用功能上的定位是：全彩屏以 高品质图像为主，满足TV。满足一切文字、字符显示，兼顾 必要的图像，二、三维动画显示。</p>
        </div>
      </div>
    </div>
    <!-- 方案优势 -->
    <div class="container clearfix">
      <div class="smart-title">方案优势</div>
      <ul class="smart-strength clearfix mb100">
        <li>
          <h2>显示系统</h2>
          <p>显示屏体：LED发光器件组成的可控显示板（显示单元和灰度系统构成； 结构骨架：屏体支撑部分，含显示单元固定架、外框架和维护架等。</p>
        </li>
        <li>
          <h2>控制系统</h2>
          <p>该系统由计算机、多媒体卡、控制卡等构成，主要用于显示数据的编辑、处理与 分配，并控制显示屏的显示。</p>
        </li>
        <li>
          <h2>编辑系统</h2>
          <p>编辑系统的作用是完成显示屏显示内容的整理、编排和设计。编辑完成后的显示 内容，须由编辑系统送入控制系统才能进行有效的时时播放。</p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Ssledscreen',
};
</script>
<style scoped>
.smart-banner {
  width: 100%;
  height: 594px;
  background: #000;
}
.smart-banner div {
  overflow: hidden;
  width: 100%;
  height: 100%;
  background: url(../../../assets/img/smart/background_Image.png) no-repeat;
  background-size: cover;
}
.smart-banner h2 {
  margin-top: 182px;
  text-align: center;
  font-size: 100px;
  font-weight: bold;
  color: #fff;
}
.smart-banner h3 {
  text-align: center;
  font-size: 30px;
  font-weight: 400;
  color: #fff;
}
.smart-title {
  width: 100%;
  margin-top: 100px;
  margin-bottom: 100px;
  text-align: center;
  font-size: 60px;
  font-weight: bold;
  color: #000;
}
.smart-overview {
  width: 100%;
  height: 334px;
}
.smart-overview p {
  font-size: 18px;
  font-weight: 400;
  color: #666;
  text-indent: 2em;
  line-height: 1.8;
}
.smart-overview h2 {
  text-align: center;
  margin-bottom: 45px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
}
.smart-strength {
  display: table;
  margin-right: -132px;
}
.smart-strength li {
  float: left;
  width: 366px;
  height: 160px;
  margin-right: 41px;
  margin-bottom: 50px;
}
.smart-strength li h2 {
  margin-bottom: 20px;
  font-size: 24px;
  font-weight: bold;
  color: #333;
}
.smart-strength li p {
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 1.6;
}
</style>
